import { Auth } from "aws-amplify";
import { Button, Link, Header, TopNavigation } from "@cloudscape-design/components";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { TopNavigationi18nStrings } from "../components/labels";
import ConfirmationModal from "../modals/ConfirmationModal";
import { useNavigate } from "react-router-dom";
import "../../styles/home-page.scss";

const TopMenuBar = () => {
    const User = useSelector((state) => state.current_user);
    const modal = useSelector((state) => state.modal);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const deleteMe = () => {
        if (User.isAdmin) {
            dispatch({ type: "notification/error", message: "As an admin you cannot delete your own account." });
            return;
        }

        Auth.deleteUser()
            .then(() => {
                dispatch({ type: "current_user/clear" });
                navigate("/");
            })
            .catch((error) => {
                console.error("Error deleting user profile", error);
                dispatch({ type: "notification/error", message: "Error deleting your own user profile." });
            });
    };

    const signOut = () => {
        Auth.signOut().then(() => {
            dispatch({ type: "current_user/clear" });
            navigate("/");
        });
    };

    let utilities = [];
    if (User.isAdmin)
        utilities = utilities.concat({
            type: "menu-dropdown",
            iconName: "settings",
            ariaLabel: "Settings",
            title: "Settings",
            items: [
                {
                    text: "Configuration",
                    href: "#/config"
                }
            ]
        });

    utilities = utilities.concat({
        type: "menu-dropdown",
        iconName: "user-profile",
        text: User.email,
        items: [
            {
                items: [
                    {
                        text: (
                            <Link
                                onFollow={() =>
                                    User.isAdmin
                                        ? dispatch({ type: "modal/open", status: "cannotDeleteMyself" })
                                        : dispatch({ type: "modal/open", status: "deleteMyself" })
                                }
                            >
                                Delete my user profile
                            </Link>
                        )
                    }
                ]
            },
            {
                text: (
                    <Button variant="primary" onClick={signOut}>
                        Sign out
                    </Button>
                )
            }
        ]
    });

    return (
        <>
            <TopNavigation
                identity={{
                    href: "#",
                    title: "AllianzTech playground",
                    logo: {
                        src: "data:image/svg+xml;base64,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",
                        alt: "AllianzTech"
                      }
                }}
                utilities={utilities}
                i18nStrings={TopNavigationi18nStrings}
                className="top-navigation"
            />
            <ConfirmationModal
                visible={modal.status === "deleteMyself"}
                action={deleteMe}
                confirmationText="delete me"
                buttonText="Delete your account"
                alert="error"
            >
                Do you really want to delete your user account "{User.email}"?
                <br />
                <strong>You will not be able to log in to Sandbox Accounts for Events any more!</strong>
            </ConfirmationModal>
            <ConfirmationModal
                visible={modal.status === "cannotDeleteMyself"}
                action={() => undefined}
                buttonText="Ok"
                alert="error"
                header={<Header>Error</Header>}
            >
                Sorry, but for security reasons admins cannot delete their own user accounts.
            </ConfirmationModal>
        </>
    );
};

export default TopMenuBar;
